import { Controller } from "@hotwired/stimulus"

// Toggle + persistence for a UI::Collapse section.
//
// The co-located <script src> UI::Collapse renders (collapse_initial_state.js)
// applies the stored/default state before first paint — the flicker-free path.
// This controller owns the click-to-toggle + localStorage write, and re-applies
// on connect as a fallback in case that script didn't run.
//
// <div data-controller="collapse"
//      data-collapse-key-value="advocate_application"
//      data-collapse-default-value="open"> … </div>
export default class extends Controller {
  static targets = ["content", "trigger", "indicator"]
  static values = {
    key: String,
    default: { type: String, default: "open" }, // "open" | "collapsed"
  }

  connect() {
    const stored = this.read()
    const collapsed = stored === null ? this.defaultValue === "collapsed" : stored === "1"
    this.apply(collapsed)
  }

  toggle() {
    const collapsed = !this.isCollapsed
    this.apply(collapsed)
    this.write(collapsed)
  }

  get isCollapsed() {
    return this.hasContentTarget && this.contentTarget.classList.contains("hidden")
  }

  apply(collapsed) {
    if (this.hasContentTarget) this.contentTarget.classList.toggle("hidden", collapsed)
    // Chevron points down (rotated) when expanded, right when collapsed.
    if (this.hasIndicatorTarget) this.indicatorTarget.classList.toggle("rotate-90", !collapsed)
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute("aria-expanded", String(!collapsed))
  }

  read() {
    try {
      return window.localStorage.getItem(this.storageKey)
    } catch (e) {
      return null
    }
  }

  write(collapsed) {
    try {
      window.localStorage.setItem(this.storageKey, collapsed ? "1" : "0")
    } catch (e) {
      // localStorage unavailable (private mode, disabled) — toggle still works for the session.
    }
  }

  get storageKey() {
    return "collapse:" + this.keyValue
  }
}
